<script>
  export let message = '';
</script>

<div class="loading">
  <svg width="38" height="38" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#000">
    <g fill="none" fill-rule="evenodd">
      <g transform="translate(1 1)" stroke-width="2">
        <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
        <path d="M36 18c0-9.94-8.06-18-18-18">
          <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
        </path>
      </g>
    </g>
  </svg>
  {#if message}
    <p>{message}</p>
  {/if}
</div>

<style lang="scss">
  .loading {
    overflow: hidden;
    touch-action: none;
    user-select: none;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    svg {
      width: 120px;
      height: 120px;
    }
    p {
      margin-top: 20px;
      color: #fff;
      font-size: 22px;
      font-weight: 600;
      text-align: center;
      padding: 0 25px;
    }
  }
</style>
